// Text for screen readers only (.mc-sr). Also the inline target of a blocked control's aria-describedby (ground
// rule 7): rendered at rest and under SSR, so the reference always resolves.

import type { ReactNode } from "react";

export function VisuallyHidden({ id, children }: { id?: string | undefined; children: ReactNode }) {
  return <span className="mc-sr" id={id}>{children}</span>;
}
